import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Colors } from 'mm-theme-configuration/dist/interfaces';
import { TYPOGRAPHY_SIZE } from 'mm-theme-configuration/dist/consts';
import { getStyleBySize } from '../../../../../typography/semanticTags/semanticTags.utils';
import { TranslatedFontSize } from '../../../../../theming/fontSizeTranslator';
import { useTheme } from '../../../../../theming/useTheme';
import { NavigationLink } from '../oldHeader/primaryHeader/PrimaryHeader';

import { Link } from '../../../../partials/link/Link';


interface MegaMenuProp {
  megaMenu: NavigationLink[];
}

const getLinksStyle = (colors: Colors) => {
  return StyleSheet.create({
    menuWrapper: {
      display: 'flex',
      padding: '24px',
      position: 'absolute',
      top: '123px',
      gap: '24px',
      zIndex: 10,
      boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.25)',
      backgroundColor: colors.white,
      textTransform: 'uppercase',
      flexWrap: 'wrap',
      width: '588px',
    },
    linksAndTitle: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    },
    linksList: {
      flex: '1',
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'column',
      gap: '4px',
      maxHeight: '230px',
      flexWrap: 'wrap',
    },
    title: {
      // @ts-ignore
      fontWeight: '700 !important',
    },
    link: {
      color: colors.darkGrey,
      display: 'flex',
      flexWrap: 'wrap',
      position: 'relative',
      alignItems: 'center',
      textDecoration: 'none',
      width: '180px',
    },
  });
};

const getChildrenArray = (megaMenu: NavigationLink[]): NavigationLink[] => {
  const result: NavigationLink[] = [];
  let parent: NavigationLink | null = null;
  megaMenu.forEach(item => {
    if (item.link.href === '') {
      parent = item;
      parent.children = [];
      result.push(parent);
    } else if (parent) {
      if (!parent.children) {
        parent.children = [];
      }
      parent.children.push(item);
    }
  });
  return result;
};

export const MegaMenuThirdRow: React.FunctionComponent<MegaMenuProp> = ({ megaMenu }) => {
  const { colors, fontSizesStyles }: { colors: Colors; fontSizesStyles: TranslatedFontSize } = useTheme();
  const fontStyle = getStyleBySize(fontSizesStyles, { fontSizeSmall: TYPOGRAPHY_SIZE.TINY, fontSizeMedium: TYPOGRAPHY_SIZE.TINY, fontSizeLarge: TYPOGRAPHY_SIZE.TINY });
  const style = getLinksStyle(colors);
  const links = getChildrenArray(megaMenu);
  return (
    <div className={css(style.menuWrapper)}>
      {links.map((navigationLink: NavigationLink, index: number) => {
        return (
          <div key={index} className={css(style.linksAndTitle)}>
            <span className={css(style.title)}>{navigationLink.link.text}</span>
            <ul className={css(style.linksList)}>
              {navigationLink.children?.map((child: NavigationLink, key: number) => {
                return (
                  <li key={key} className={css(style.link)}>
                    <Link className={css(style.link, fontStyle)} href={child.link.href}>
                      <span>{child.link.text}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </div>
  );
};
